import React from "react"
import "./aboutUs.css"
import { useTranslation } from "react-i18next"
import { clientInfo } from "../../resources";

export default function AboutUs() {
    const { t } = useTranslation()
    const abtUs = t('aboutUs.aboutUs.desc', { boldText: clientInfo.brand });
    const platform = t('aboutUs.platform.desc', { boldText: clientInfo.brand });
    const why = t('aboutUs.why.desc', { boldText: clientInfo.brand });
    const pont1 = t('aboutUs.platform.point1', { boldText: `<strong>${clientInfo.brand}</strong>` });
    const pont2 = t('aboutUs.platform.point2', { boldText: `<strong>${clientInfo.brand}</strong>` });
    const future = t('aboutUs.future.desc', { boldText: clientInfo.brand });
    const promote = t('aboutUs.promote.desc', { boldText: clientInfo.brand });

    return (
        <>
            <div className="each_blade">
                <div className="left">
                    <h2>{ t('aboutUs.aboutUs.title') }</h2>
                </div>
                <div className="right">
                    <p dangerouslySetInnerHTML={ { __html: abtUs } } />
                </div>
            </div>
            <div className="each_blade">
                <div className="left">
                    <h2>{ t('aboutUs.platform.title') }</h2>
                </div>
                <div className="right">
                    <p style={ { textAlign: 'left' } } dangerouslySetInnerHTML={ { __html: platform } } />
                    <ul>
                        <li dangerouslySetInnerHTML={ { __html: pont1 } } />
                        <br />
                        <li dangerouslySetInnerHTML={ { __html: pont2 } } />
                    </ul>
                </div>
            </div>
            <div className="each_blade">
                <div className="left">
                    <h2>{ t('aboutUs.future.title') }</h2>
                </div>
                <div className="right">
                    <p dangerouslySetInnerHTML={ { __html: future } } />
                </div>
            </div>
            <div className="each_blade">
                <div className="left">
                    <h2>{ t('aboutUs.why.title') }</h2>
                </div>
                <div className="right">
                    <p dangerouslySetInnerHTML={ { __html: why } } />
                </div>
            </div>
            <div className="promote">
                <div className="left">
                    <img alt="prom" src="img/prom.png" />
                </div>
                <div className="right">
                    <strong>{ t('aboutUs.promote.title') }</strong>
                    <p dangerouslySetInnerHTML={ { __html: promote } } />
                </div>
            </div>
        </>
    )
}